import Vue from 'vue'
import VueRouter from 'vue-router'
import { APP_CONFIG } from '@/config'
import { getPublicConfig, fetchPublicConfig, resolveShopShortName } from '@/utils/publicConfig'
import store from '@/store'
import Home from '../views/Home.vue'
import loginpage from '@/views/loginpage'
import registered from '@/views/signuppage'
import ForgotPassword from '@/views/ForgotPassword'
import Order from '@/views/Order'
import Cart from '@/views/Cart'
import Center from '@/views/Center'
import Search from '@/views/Search'
import CameraTest from '@/views/CameraTest'
import Result from '@/views/Result'
import Nopage from '@/views/Nopage'
import Detailspage from '@/views/Detailspage'
import TestPage from '@/views/Test'
import Promotion from '@/views/Promotion'
import Hot from '@/views/Hot'
import NewArrival from '@/views/NewArrival'
import Favorites from '@/views/Favorites'
import Campaign from '@/views/Campaign'

// PC admin pages
import AdminLayout from '@/views/admin/AdminLayout'
import Dashboard from '@/views/admin/Dashboard'
import UserManage from '@/views/admin/UserManage'
import OrderManage from '@/views/admin/OrderManage'
import OrderArchive from '@/views/admin/OrderArchive'
import ProductManage from '@/views/admin/ProductManage'
import PromotionManage from '@/views/admin/PromotionManage'
import GiftManage from '@/views/admin/GiftManage'
import HomePageManage from '@/views/admin/HomePageManage'
import ProductTagsManage from '@/views/admin/ProductTagsManage'
import CategoryManage from '@/views/admin/CategoryManage'
const HotSearchManage = () => import('@/views/admin/HotSearchManage.vue')

// Mobile admin pages
import AdminMobileDashboard from '@/views/admin-mobile/AdminMobileDashboard'
import AdminAssignCourier from '@/views/admin-mobile/AdminAssignCourier'
import AdminProductEdit from '@/views/admin-mobile/AdminProductEdit'
import AdminPromotionManage from '@/views/admin-mobile/AdminPromotionManage'
import GiftPromotionList from '@/views/admin-mobile/GiftPromotionList'
import GiftPromotionEdit from '@/views/admin-mobile/GiftPromotionEdit'

// Courier mobile pages
import CourierMobileOrders from '@/views/courier-mobile/CourierMobileOrders'
import CourierMobileOrderDetail from '@/views/courier-mobile/CourierMobileOrderDetail'

// Operator 差异通过组件注入共享 Order/Home/Center，不再有独立页面（黄金法则）

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'index',
    component: loginpage,
    meta: {
      navShow: false,
      noPageShow: false,
      keepAlive: true,
      title: '登录'
    }
  },
  {
    path: '/registered',
    name: 'sign up',
    component: registered,
    meta: {
      navShow: false,
      noPageShow: false,
      keepAlive: true,
      title: '注册账户'
    }
  },
  {
    // 忘记密码（自助重置）：预登录页，未登录可进；与 /registered 同模式
    path: '/forgot-password',
    name: 'forgotPassword',
    component: ForgotPassword,
    meta: {
      navShow: false,
      noPageShow: false,
      keepAlive: false,
      title: '找回密码'
    }
  },
  {
    path: '/home',
    name: 'Home',
    component: Home,
    meta: {
      navShow: true,
      noPageShow: false,
      keepAlive: true,
      title: '主页'
    }
  },
  {
    path: '/order',
    name: 'Order',
    component: Order,
    meta: {
      navShow: true,
      noPageShow: false,
      keepAlive: false,
      title: '订单'
    }
  },
  {
    path: '/cart',
    name: 'Cart',
    component: Cart,
    meta: {
      navShow: false,
      noPageShow: false,
      keepAlive: false,
      title: '购物车'
    }
  },
  {
    path: '/center',
    name: 'Center',
    component: Center,
    meta: {
      navShow: true,
      noPageShow: false,
      keepAlive: false,
      title: '个人中心'
    }
  },
  {
    path: '/account',
    name: 'Account',
    component: () => import('@/views/Account.vue'),
    meta: { title: '账号管理', navShow: false, noPageShow: true }
  },
  // 帮助中心：列表按角色下发（后端过滤），正文仅从 /api/help/:slug 按角色获取——
  // 受限文档（如管理员手册）不打包进公开前端 bundle，无权角色直敲 URL 只见 404 空态
  {
    path: '/help',
    name: 'Help',
    component: () => import('@/views/Help.vue'),
    meta: { title: '帮助中心', navShow: false, noPageShow: true }
  },
  {
    path: '/help/:slug',
    name: 'HelpArticle',
    component: () => import('@/views/HelpArticle.vue'),
    meta: { title: '帮助中心', navShow: false, noPageShow: true }
  },
  {
    path: '/favorites',
    name: 'Favorites',
    component: Favorites,
    meta: {
      navShow: false,
      noPageShow: false,
      keepAlive: false,
      title: '我的收藏'
    }
  },
  {
    path: '/campaign',
    name: 'CampaignPage',
    component: Campaign,
    meta: {
      navShow: false,
      noPageShow: false,
      keepAlive: false,
      title: '活动详情' // 实际标题由 query.title 动态覆盖（组件 mounted/watch）
    }
  },
  {
    path: '/promotion',
    name: 'Promotion',
    component: Promotion,
    meta: {
      navShow: false,
      noPageShow: false,
      keepAlive: false,
      title: '促销优惠'
    }
  },
  {
    // 运营专区 landing（Merchandising Phase 2）：独立路由 /hub/:slug（spec §5，不用 /result?q=）
    // 游客可看（与商品列表同级公开陈列）；实际标题由专区名动态覆盖
    path: '/hub/:slug',
    name: 'HubPage',
    component: () => import('@/views/HubPage.vue'),
    meta: {
      navShow: false,
      noPageShow: false,
      keepAlive: false,
      title: '专区'
    }
  },
  {
    path: '/hot',
    name: 'Hot',
    component: Hot,
    meta: {
      navShow: false,
      noPageShow: false,
      keepAlive: false,
      title: '热销好货'
    }
  },
  {
    path: '/new',
    name: 'NewArrival',
    component: NewArrival,
    meta: {
      navShow: false,
      noPageShow: false,
      keepAlive: false,
      title: '新品上架'
    }
  },
  {
    path: '/search',
    name: 'search',
    component: Search,
    meta: {
      noPageShow: false,
      title: '搜索页'
    }
  },
  {
    path: '/search/:data',
    name: 'toSearch',
    component: Search,
    meta: {
      noPageShow: false,
      title: '搜索页'
    }
  },
  {
    path: '/camera-test',
    name: 'CameraTest',
    component: CameraTest,
    meta: { title: '摄像头诊断' }
  },
  {
    path: '/result',
    name: 'toResult',
    component: Result,
    meta: {
      noPageShow: true,
      title: '搜索结果'
    }
  },
  {
    path: '/details',
    name: 'toDetails',
    component: Detailspage,
    meta: {
      noPageShow: true,
      title: '详情页'
    }
  },
  {
    path: '/test',
    name: 'testPage',
    component: TestPage,
    meta: {
      noPageShow: true,
      navShow: false,
      title: '测试页'
    }
  },
  {
    // dev 验收页：仅开发环境可见，生产构建 beforeEach 按 NODE_ENV 拦截重定向 /home
    path: '/dev/unit-playground',
    name: 'UnitPlayground',
    component: () => import('@/views/dev/UnitPlayground.vue'),
    meta: { title: '单位Playground', navShow: false, noPageShow: true, devOnly: true }
  },
  {
    // dev 推荐验收台：只读观察推荐输出（为什么推荐/是否符合直觉），生产环境不可达
    path: '/dev/recommend-playground',
    name: 'RecommendPlayground',
    component: () => import('@/views/dev/RecommendPlayground.vue'),
    meta: { title: '推荐Playground', navShow: false, noPageShow: true, devOnly: true }
  },
  {
    // dev 画像推荐消费实验：A/B 对比验证画像能否改善排序，生产环境不可达
    path: '/dev/profile-recommend-test',
    name: 'ProfileRecommendTest',
    component: () => import('@/views/dev/ProfileRecommendTest.vue'),
    meta: { title: '画像推荐实验', navShow: false, noPageShow: true, devOnly: true }
  },
  {
    // dev 推荐信号校准实验台：4方案(A baseline/B model封顶/C model比例限制/D 联合品牌)对比排名变化+因子贡献+风险案例，生产环境不可达
    path: '/dev/recommend-calibration',
    name: 'RecommendCalibration',
    component: () => import('@/views/dev/RecommendCalibration.vue'),
    meta: { title: '推荐信号校准', navShow: false, noPageShow: true, devOnly: true }
  },
  {
    // dev MCP WebChat 测试入口：真实LLM/离线DemoProvider 双模式，经 Agent Runner→Tool 链路跑 search→draft→confirm，生产环境不可达
    path: '/dev/mcp-chat',
    name: 'McpChat',
    component: () => import('@/views/dev/McpChat.vue'),
    meta: { title: 'MCP WebChat', navShow: false, noPageShow: true, devOnly: true }
  },
  {
    path: '/admin',
    component: AdminLayout,
    redirect: '/admin/dashboard',
    meta: { title: '后台管理', navShow: false, noPageShow: true, requireAdmin: true },
    children: [
      {
        path: 'dashboard',
        name: 'AdminDashboard',
        component: Dashboard,
        meta: { title: '数据概览' }
      },
      {
        path: 'users',
        name: 'AdminUsers',
        component: UserManage,
        meta: { title: '用户管理' }
      },
      {
        path: 'orders',
        name: 'AdminOrders',
        component: OrderManage,
        meta: { title: '订单管理' }
      },
      {
        path: 'orders/archive',
        name: 'AdminOrderArchive',
        component: OrderArchive,
        meta: { title: '订单归档' }
      },
      {
        path: 'products',
        name: 'AdminProducts',
        component: ProductManage,
        meta: { title: '商品管理' }
      },
      {
        path: 'product-categories',
        name: 'CategoryManage',
        component: CategoryManage,
        meta: { title: '品类管理' }
      },
      {
        path: 'product-frames',
        name: 'ProductFrameManage',
        component: () => import('@/views/admin/ProductFrameManage.vue'),
        meta: { title: '商品边框' }
      },
      {
        path: 'product-tags',
        name: 'ProductTagsManage',
        component: ProductTagsManage,
        meta: { title: '标签管理' }
      },
      {
        path: 'hot-search',
        name: 'HotSearchManage',
        component: HotSearchManage,
        meta: { title: '热搜配置' }
      },
      {
        path: 'merchandising',
        name: 'MerchandisingManage',
        component: () => import('@/views/admin/MerchandisingManage.vue'),
        meta: { title: '专区运营' }
      },
      {
        path: 'system',
        name: 'SystemSetting',
        component: () => import('@/views/admin/SystemSetting.vue'),
        meta: { title: '系统设置' }
      },
      {
        path: 'homepage',
        name: 'HomePageManage',
        component: HomePageManage,
        meta: { title: '主页管理' }
      },
      {
        path: 'promotions',
        name: 'PromotionManage',
        component: PromotionManage,
        meta: { title: '促销活动' }
      },
      {
        path: 'coupons',
        name: 'AdminCouponManage',
        component: () => import('@/views/admin/CouponManage.vue'),
        meta: { title: '优惠管理' }
      },
      {
        path: 'gifts',
        name: 'GiftManage',
        component: GiftManage,
        meta: { title: '赠品管理' }
      },
      {
        path: 'authorization-codes',
        name: 'AdminAuthorizationCodes',
        component: () => import('@/views/admin/AuthorizationCodes.vue'),
        meta: { title: '授权管理' }
      },
      {
        path: 'pre-users',
        name: 'AdminPreUsers',
        component: () => import('@/views/admin/PreUsers.vue'),
        meta: { title: '预备用户' }
      },
      {
        path: 'registration-requests',
        name: 'AdminRegistrationRequests',
        component: () => import('@/views/admin/RegistrationRequests.vue'),
        meta: { title: '注册申请' }
      },
      // 帮助中心管理（二阶段）：super_admin 专属（父级 requireAdmin + 此处 requireSuperAdmin 双闸）；
      // 列表/编辑页懒加载分包——marked 只进编辑 chunk，不进主 bundle
      {
        path: 'help',
        name: 'AdminHelpManage',
        component: () => import('@/views/admin/HelpManage.vue'),
        meta: { title: '帮助管理', requireSuperAdmin: true }
      },
      {
        path: 'help/create',
        name: 'AdminHelpCreate',
        component: () => import('@/views/admin/HelpArticleEdit.vue'),
        meta: { title: '新建帮助文章', requireSuperAdmin: true }
      },
      {
        path: 'help/:id/edit',
        name: 'AdminHelpEdit',
        component: () => import('@/views/admin/HelpArticleEdit.vue'),
        meta: { title: '编辑帮助文章', requireSuperAdmin: true }
      }
    ]
  },
  {
    path: '/admin-mobile',
    component: AdminMobileDashboard,
    meta: { title: '管理首页', navShow: false, noPageShow: true, requireAdmin: true }
  },
  {
    path: '/courier/orders',
    component: CourierMobileOrders,
    meta: { title: '配送订单', navShow: false, noPageShow: true, requireCourier: true }
  },
  {
    path: '/courier/orders/:id',
    component: CourierMobileOrderDetail,
    meta: { title: '订单详情', navShow: false, noPageShow: true, requireCourier: true }
  },
  // Operator 不再单开页面：登录后用统一 /home /order /center，差异由组件注入
  {
    path: '/order/:id/inspection',
    component: () => import('@/views/admin-mobile/OrderInspection.vue'),
    meta: { title: '验货', navShow: false, noPageShow: true, requireAdmin: true }
  },
  // operator 验货页 = admin 验货页同款 UI，仅 API 换 /operator-mobile（requireOperator）
  {
    path: '/operator/order/:id/inspection',
    component: () => import('@/views/operator-mobile/OperatorInspection.vue'),
    meta: { title: '验货', navShow: false, noPageShow: true, requireOperator: true }
  },
  // operator 指派配送页 = admin 同款 UI，仅 API 换 /operator-mobile
  {
    path: '/operator/order/:id/assign',
    component: () => import('@/views/operator-mobile/OperatorAssignCourier.vue'),
    meta: { title: '指派配送员', navShow: false, noPageShow: true, requireOperator: true }
  },
  {
    path: '/order/:id/assign',
    component: AdminAssignCourier,
    meta: { title: '指派配送员', navShow: false, noPageShow: true, requireAdmin: true }
  },
  {
    path: '/order/:id/ship',
    name: 'AdminShip',
    component: () => import('@/views/admin-mobile/AdminShip.vue'),
    meta: { title: '发货', navShow: false, noPageShow: true, requireAdmin: true }
  },
  {
    path: '/product/:id/edit',
    component: AdminProductEdit,
    meta: { title: '编辑商品', navShow: false, noPageShow: true, requireAdmin: true }
  },
  {
    path: '/product/add',
    component: AdminProductEdit,
    meta: { title: '新增商品', navShow: false, noPageShow: true, requireAdmin: true }
  },
  {
    path: '/admin/promotions',
    component: AdminPromotionManage,
    meta: { title: '满赠活动', navShow: false, noPageShow: true, requireAdmin: true }
  },
  {
    path: '/admin/gift-promotions',
    component: GiftPromotionList,
    meta: { title: '满赠活动管理', navShow: false, noPageShow: true, requireAdmin: true }
  },
  {
    path: '/admin/gift-promotions/create',
    component: GiftPromotionEdit,
    meta: { title: '新建满赠活动', navShow: false, noPageShow: true, requireAdmin: true }
  },
  {
    path: '/admin/gift-promotions/:id/edit',
    component: GiftPromotionEdit,
    meta: { title: '编辑满赠活动', navShow: false, noPageShow: true, requireAdmin: true }
  },
  {
    path: '/admin-mobile/coupons',
    component: () => import('@/views/admin-mobile/CouponManage.vue'),
    meta: { title: '优惠券管理', navShow: false, noPageShow: true, requireAdmin: true }
  },
  {
    path: '/admin-mobile/authorization-codes',
    component: () => import('@/views/admin-mobile/AuthorizationCodes.vue'),
    meta: { title: '授权码管理', navShow: false, noPageShow: true, requireAdmin: true }
  },
  {
    path: '/my-coupons',
    component: () => import('@/views/MyCoupons.vue'),
    meta: { title: '我的优惠券', navShow: false, noPageShow: true }
  },
  {
    path: '*',
    name: 'noPage',
    component: Nopage,
    meta: {
      noPageShow: true,
      navShow: false
    }
  }
]

// ===== dev-only 路由：HV Playground（2026-10-09）=====
// 生产构建整支消除：DefinePlugin 把 NODE_ENV 折叠为常量 'production'，if(false) 分支连同
// 其中的动态 import() 一起被 DCE（chunk 不产出）——构建后已在 dist 反证确认无 hv-playground 产物。
if (process.env.NODE_ENV === 'development') {
  routes.push({
    path: '/dev/hv-playground',
    name: 'hvPlayground',
    component: () => import('@/views/dev/HvPlayground.vue'),
    meta: {
      navShow: false,
      noPageShow: false,
      keepAlive: false,
      title: 'HV Playground'
    }
  })
}

const router = new VueRouter({
  mode: 'history',
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    return { x: 0, y: 0 }
  },
  base: process.env.BASE_URL,
  routes
})

const whiteList = ['/', '/registered', '/forgot-password', '/campaign'] // /campaign：运营落地页，未登录可看（Banner 直达）
if (process.env.NODE_ENV === 'development') whiteList.push('/dev/hv-playground') // dev-only：Playground 免登录可进（生产构建本行消除）

router.beforeEach((to, from, next) => {
  // Tab 标题两层（2026-09-11）：业务页 = 页面名-店铺名（店铺名空=纯页面名）；meta.title 缺失的
  // 异常路径才兜底系统品牌。店铺名优先同步读缓存；整页直进缓存冷时异步拉一次到货补后缀
  // （模块自身去重，全站只发一条请求）——覆盖分享链接/刷新直进场景。
  // 2026-09-14 店铺简称：后缀统一走 resolveShopShortName（简称→店铺名称），全站含首页同规则
  // （主页-老周汽配）。系统品牌只出现在两处：vue.config.js bake 的加载瞬间兜底 + meta.title
  // 缺失的异常路径——不进正常业务页标题。
  const pageTitle = to.matched[0] && to.matched[0].meta && to.matched[0].meta.title
  const applyTitle = (shop) => {
    document.title = pageTitle
      ? (shop ? `${pageTitle}-${shop}` : pageTitle)
      : APP_CONFIG.systemBrandNameZh
  }
  const cached = getPublicConfig()
  applyTitle(cached && resolveShopShortName(cached))
  if (!cached) {
    fetchPublicConfig()
      .then(cfg => { if (to === router.currentRoute) applyTitle(resolveShopShortName(cfg)) })
      .catch(() => { /* 拉取失败保持纯页面名 */ })
  }

  // 路由守卫角色真值统一走 store getter（spec A/F）：store 初始化自 localStorage、
  // setUser/clearUser 双写保持镜像，且 main.js 启动复核 /user/info 后 commit 即反映到
  // 这里——不再各处裸读 localStorage.user 自己解析，角色口径单一收口 isAdmin/isSuperAdmin/isOperator
  const token = localStorage.getItem('token')

  if (whiteList.includes(to.path)) {
    if (token && to.path === '/') {
      next({ path: '/home' })
      return
    }
    next()
    return
  }

  if (!token) {
    // 帮助中心（2026-09-17 用户拍板）：页面骨架对游客可见——列表/正文 API 仍 401 零泄露，
    // 页内展示「登录后查看」引导卡（Help.vue / HelpArticle.vue），登录后回跳原页
    const guestHelp = to.path === '/help' || to.path.startsWith('/help/')
    // 运营专区 landing：公开陈列（路由定义注释「游客可看」的落地）——后端
    // /api/merchandising/hubs/:slug 本就游客可达，此前守卫漏放行导致未登录被踹回登录页
    const guestHub = to.path.startsWith('/hub/')
    if (!guestHelp && !guestHub) {
      const redirect = to.fullPath !== '/' ? to.fullPath : undefined
      next({ path: '/', query: redirect ? { redirect } : undefined })
      return
    }
  }

  if (to.meta.requireAdmin) {
    if (!store.getters.isAdmin) {
      next('/home')
      return
    }
  }

  if (to.meta.requireOperator) {
    if (!store.getters.isOperator) {
      next('/home')
      return
    }
  }

  if (to.meta.requireSuperAdmin) {
    if (!store.getters.isSuperAdmin) {
      next('/home')
      return
    }
  }

  // dev-only 路由：生产环境一律重定向，确保验收页不进生产包可达路径
  if (to.meta.devOnly && process.env.NODE_ENV === 'production') {
    next('/home')
    return
  }

  next()
})

export default router
